import { Button, Flex, Heading, Paragraph } from '@zillow/constellation';
import type { CreditReportType } from '@zg-rentals/ts-capps-client';
import type { UserStatus } from '../../../graphql/queries';
import { CreditReportAlertSmall, isCreditReportViewable } from '../BackgroundReport/BackgroundReportAlert';
import { getIsCreditReportValid } from '../../../utils/user-statuses';

export function CreditReportOverview({
  creditReport,
  userStatuses,
  onView,
}: {
  creditReport?: CreditReportType;
  userStatuses: Array<UserStatus>;
  onView: () => void;
}) {
  const isCreditReportValid = getIsCreditReportValid(userStatuses);
  const creditReportVisible = isCreditReportViewable(creditReport);
  const creditScoreDisplay =
    isCreditReportValid && creditReportVisible && creditReport ? creditReport.creditScore || 'N/A' : '-';

  return (
    <Flex display="flex" justifyContent="space-between" alignItems="start">
      <Flex display="flex" flexDirection="column" gap="xs">
        <Heading level={6}>Credit report</Heading>
        <CreditReportAlertSmall creditReport={creditReport} />
        <Heading level={6} as="h3" fontColor="textMedium" fontType="bodySmall">
          Credit score
        </Heading>
        <Paragraph>
          <strong>{creditScoreDisplay}</strong>
        </Paragraph>
      </Flex>
      <Button
        size="sm"
        onClick={onView}
        disabled={!isCreditReportValid || !creditReportVisible}
        type="button"
        aria-label="View credit report"
      >
        View
      </Button>
    </Flex>
  );
}
